var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11767_14954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.023 18.7977H11.6115C11.7489 19.8632 12.1536 20.8767 12.7879 21.7438L11.6574 22.877C10.7402 21.6978 10.1738 20.284 10.023 18.7977ZM18.795 11.6144V10.0126C20.7644 10.2173 22.5887 11.1431 23.9169 12.6119C25.2427 14.0784 25.9803 15.9824 25.9887 17.9588L25.9887 17.9587L25.9886 17.9812C25.983 19.9634 25.2435 21.8735 23.9128 23.3428C22.585 24.8089 20.7623 25.7326 18.795 25.9366V24.3481C20.3413 24.1494 21.7625 23.3948 22.7933 22.2249C23.8262 21.0526 24.3961 19.5438 24.3961 17.9813C24.3961 16.4188 23.8262 14.91 22.7933 13.7376C21.7625 12.5677 20.3412 11.8132 18.795 11.6144ZM12.7772 14.2158C12.1429 15.0839 11.7382 16.0982 11.6009 17.1646H10.0124C10.1631 15.6783 10.7294 14.2645 11.6466 13.0853L12.7772 14.2158ZM17.1619 11.6142C15.9616 11.765 14.829 12.2538 13.896 13.0238L12.7734 11.9012C14.0086 10.8375 15.5403 10.1782 17.1619 10.0124V11.6142ZM16.3655 14.3794L21.1679 17.9812L16.3655 21.5829V14.3794ZM17.1619 25.9473C15.5399 25.7826 14.0079 25.1232 12.7734 24.0584L13.8959 22.9359C14.8276 23.7106 15.9603 24.2041 17.1619 24.3588V25.9473Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.0223713
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11767_14954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotion);
export default __webpack_public_path__ + "static/media/Motion.812e684f093dcdf88fd33d59306f6244.svg";
export { ForwardRef as ReactComponent };